module.exports = (__webpack_require__(24))(15);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/createClass.js from dll-reference lib_core
// module id = 148
// module chunks = 109